import Request from '../Request.utils'
export interface IGetApprovedBuyingListRequestQuery {
  locationExternalId: string | '' | null;
  offset?: number;
  search?: string | '' | null;
}
export interface ICreateShopifyOrderRequestBody {
  lineItems: ({
    budgetCategory?: string | '' | null;
    quantity: number;
    variantId: string;
  })[];
  locationExternalId?: string | '' | null;
  note?: string | '' | null;
  poNumber?: string | '' | null;
  requirePayment?: boolean;
  source?: string | '' | null;
}
export interface IListShopifyOrderRequestQuery {
  details?: boolean;
  endDate?: string;
  hasDeliveryStatus?: 'false' | 'true' | '1' | '0';
  isBackOrder?: boolean;
  limit?: number;
  liveDeliveryOnly?: '' | 'true' | 'false' | '1' | '0';
  locationExternalId?: string;
  offset?: number;
  orderBy?: 'createdAt' | 'updatedAt';
  search?: string;
  startDate?: string;
  status?: string;
}
export interface IShopifyOrderRequestQuery {
  id: string;
}
export interface ICreateOrderIssueRequestBody {
  attachFiles?: string[];
  description: string;
  orderId: string;
  orderType?: 'shopify' | 'bc';
  type: 'missing' | 'wrong-item' | 'damaged' | 'other';
}
export interface IUpdateOrderIssueRequestBody {
  attachFiles?: string[];
  description?: string;
  id: string;
  status?: 'pending' | 'in-progress' | 'resolved' | 'rejected';
  type?: 'missing' | 'wrong-item' | 'damaged' | 'other';
}
export interface IGetOrderIssueRequestQuery {
  id: string;
}
export interface IListOrderIssuesRequestQuery {
  details?: boolean;
  limit?: number;
  offset?: number;
  orderBy?: 'createdAt' | 'updatedAt';
  orderId?: string;
  status?: 'pending' | 'in-progress' | 'resolved' | 'rejected';
  type?: 'missing' | 'wrong-item' | 'damaged' | 'other';
}
export interface ICreateChatMessageRequestBody {
  attachFiles?: string[];
  issueId: string;
  message: string;
}
export interface IListChatMessagesRequestQuery {
  afterTimestamp?: string;
  issueId: string;
  limit?: number;
  offset?: number;
}
export interface IGetBudgetCategoryRequestParams {
  locationId: string;
}
export interface IListDashboardSnapshotsRequestQuery {
  endDate?: string;
  limit?: number;
  offset?: number;
  orderBy?: 'snapshotDate' | 'createdAt';
  startDate?: string;
}
export interface ISubmitBackorderActionRequestBody {
  action: 'wait' | 'speak' | 'cancel';
  orderId: string;
}
export interface IUpdateOrderDataRequestBody {
  data: object;
  orderId: string;
}
export interface ISyncLast60DaysOrdersRequestBody {
  isRealOrder?: boolean;
  purchasing_company_id?: string | number;
}
export interface ISyncSpecificShopifyOrderRequestBody {
  isRealOrder: boolean;
  order_ids: string[];
}
export interface IAddOrderNoteRequestBody {
  action: 'add' | 'update' | 'delete';
  noteContent?: string;
  noteId?: string;
  orderId: string;
}
export interface IIsBackOrderRequestBody {
  draftOrderId?: string;
  orderId?: string;
  sorId?: string;
}
export interface ISyncCatalogsForLocationRequestBody {
  locationExternalId?: string;
  locationId?: string;
}
export interface ISyncPriceListCatalogRequestBody {
  priceListCode: string;
}
export interface ISyncPriceListCatalogStatusRequestQuery {
  jobId: string;
}
export interface ISyncApprovedBuyingListByLocationRequestBody {
  dryRun?: boolean;
  locationExternalId?: string;
  locationId?: string;
}
export interface ISyncApprovedBuyingListByCompanyRequestBody {
  companyId?: string;
  dryRun?: boolean;
  externalId?: string;
}
export interface ISyncApprovedBuyingListByLocationStatusRequestQuery {
  jobId: string;
}
export interface IApproveDraftOrderRequestBody {
  amendmentReason?: string;
  amendments?: {
    lineItemId: string;
    quantity?: number;
    removed?: boolean;
  }[];
  approveOverBudget?: boolean;
  draftOrderId: string;
}
export interface IGetDraftOrderRequestQuery {
  draftOrderId: string;
}
export interface ISaveDraftOrderAmendmentRequestBody {
  amendmentReason?: string;
  amendments?: {
    lineItemId: string;
    quantity?: number;
    removed?: boolean;
  }[];
  draftOrderId: string;
}
export interface IResetDraftOrderAmendmentRequestBody {
  draftOrderId: string;
}
export interface IListDraftOrdersRequestQuery {
  endDate?: string;
  limit?: number;
  locationExternalId?: string;
  offset?: number;
  search?: string;
  startDate?: string;
  status?: 'pending' | 'approved' | 'denied';
}
export interface IListLocationsRequestQuery {
  page?: number;
  pageSize?: number;
  search?: string;
}
export interface ICancelDraftOrderRequestBody {
  draftOrderId: string;
}
export interface ISyncCompanyLocationAblFromShopifyRequestBody {
  all?: boolean;
  companyId?: string | '' | null;
  locationId?: string | '' | null;
}
export interface IUpdateDraftOrderPoNumberRequestBody {
  draftOrderId: string;
  poNumber: string;
}
export interface ISyncAblMasterFromShopifyByCompanyRequestBody {
  all?: boolean;
  companyId?: string | '' | null;
  shopifyDelayMs?: number;
  shopifyMaxRetries?: number;
}
export interface ISyncBCCompanyLocationsRequestBody {
  companyExternalId: string;
}
export interface ISyncBCCompanyLocationsStatusRequestQuery {
  jobId: string;
}


class ShopifyAPI {
  getMyLocations = async () => {
    const res = await Request.call('/api/shopify/my-locations', 'GET', undefined, undefined, undefined, );
    return res;
  }
  getApprovedBuyingList = async (query: IGetApprovedBuyingListRequestQuery) => {
    const res = await Request.call('/api/shopify/approved-buying-list', 'GET', undefined, query, undefined, );
    return res;
  }
  createShopifyOrder = async (body: ICreateShopifyOrderRequestBody) => {
    const res = await Request.call('/api/shopify/create-shopify-order', 'POST', undefined, undefined, body, );
    return res;
  }
  listShopifyOrder = async (query: IListShopifyOrderRequestQuery) => {
    const res = await Request.call('/api/shopify/list-shopify-order', 'GET', undefined, query, undefined, );
    return res;
  }
  getOrderStats = async () => {
    const res = await Request.call('/api/shopify/order-stats', 'GET', undefined, undefined, undefined, );
    return res;
  }
  shopifyOrder = async (query: IShopifyOrderRequestQuery) => {
    const res = await Request.call('/api/shopify/get-shopify-order', 'GET', undefined, query, undefined, );
    return res;
  }
  createOrderIssue = async (body: ICreateOrderIssueRequestBody) => {
    const res = await Request.call('/api/shopify/create-order-issue', 'POST', undefined, undefined, body, );
    return res;
  }
  updateOrderIssue = async (body: IUpdateOrderIssueRequestBody) => {
    const res = await Request.call('/api/shopify/update-order-issue', 'POST', undefined, undefined, body, );
    return res;
  }
  getOrderIssue = async (query: IGetOrderIssueRequestQuery) => {
    const res = await Request.call('/api/shopify/get-order-issue', 'GET', undefined, query, undefined, );
    return res;
  }
  listOrderIssues = async (query: IListOrderIssuesRequestQuery) => {
    const res = await Request.call('/api/shopify/list-order-issues', 'GET', undefined, query, undefined, );
    return res;
  }
  createChatMessage = async (body: ICreateChatMessageRequestBody) => {
    const res = await Request.call('/api/shopify/create-chat-message', 'POST', undefined, undefined, body, );
    return res;
  }
  listChatMessages = async (query: IListChatMessagesRequestQuery) => {
    const res = await Request.call('/api/shopify/list-chat-messages', 'GET', undefined, query, undefined, );
    return res;
  }
  getBudgetCategory = async (params: IGetBudgetCategoryRequestParams) => {
    const res = await Request.call('/api/shopify/location/:locationId/budget-category', 'GET', params, undefined, undefined, );
    return res;
  }
  draftOrderWebhook = async () => {
    const res = await Request.call('/api/shopify/draft-order-webhook', 'POST', undefined, undefined, undefined, );
    return res;
  }
  orderWebhook = async () => {
    const res = await Request.call('/api/shopify/order-webhook', 'POST', undefined, undefined, undefined, );
    return res;
  }
  customerWebhook = async () => {
    const res = await Request.call('/api/shopify/customer-webhook', 'POST', undefined, undefined, undefined, );
    return res;
  }
  companyContactRolesWebhook = async () => {
    const res = await Request.call('/api/shopify/company-contact-roles-webhook', 'POST', undefined, undefined, undefined, );
    return res;
  }
  companyLocationsWebhook = async () => {
    const res = await Request.call('/api/shopify/company-locations-webhook', 'POST', undefined, undefined, undefined, );
    return res;
  }
  companiesWebhook = async () => {
    const res = await Request.call('/api/shopify/companies-webhook', 'POST', undefined, undefined, undefined, );
    return res;
  }
  listDashboardSnapshots = async (query: IListDashboardSnapshotsRequestQuery) => {
    const res = await Request.call('/api/shopify/list-dashboard-snapshots', 'GET', undefined, query, undefined, );
    return res;
  }
  getDashboardMetrics = async () => {
    const res = await Request.call('/api/shopify/get-dashboard-metrics', 'GET', undefined, undefined, undefined, );
    return res;
  }
  bcOrderEvent = async () => {
    const res = await Request.call('/api/shopify/bc-order-event', 'POST', undefined, undefined, undefined, );
    return res;
  }
  submitBackorderAction = async (body: ISubmitBackorderActionRequestBody) => {
    const res = await Request.call('/api/shopify/submit-backorder-action', 'POST', undefined, undefined, body, );
    return res;
  }
  updateOrderData = async (body: IUpdateOrderDataRequestBody) => {
    const res = await Request.call('/api/shopify/update-order-data', 'POST', undefined, undefined, body, );
    return res;
  }
  orderCancelledWebhook = async () => {
    const res = await Request.call('/api/shopify/order-cancelled-webhook', 'POST', undefined, undefined, undefined, );
    return res;
  }
  syncLast60DaysOrders = async (body: ISyncLast60DaysOrdersRequestBody) => {
    const res = await Request.call('/api/shopify/sync-last-60-days-orders', 'POST', undefined, undefined, body, );
    return res;
  }
  syncSpecificShopifyOrder = async (body: ISyncSpecificShopifyOrderRequestBody) => {
    const res = await Request.call('/api/shopify/sync-specific-shopify-order', 'POST', undefined, undefined, body, );
    return res;
  }
  addOrderNote = async (body: IAddOrderNoteRequestBody) => {
    const res = await Request.call('/api/shopify/manage-order-notes', 'POST', undefined, undefined, body, );
    return res;
  }
  isBackOrder = async (body: IIsBackOrderRequestBody) => {
    const res = await Request.call('/api/shopify/is-back-order', 'POST', undefined, undefined, body, );
    return res;
  }
  syncCatalogsForLocation = async (body: ISyncCatalogsForLocationRequestBody) => {
    const res = await Request.call('/api/shopify/sync-catalogs-for-location', 'POST', undefined, undefined, body, );
    return res;
  }
  syncPriceListCatalog = async (body: ISyncPriceListCatalogRequestBody) => {
    const res = await Request.call('/api/shopify/sync-price-list-catalog', 'POST', undefined, undefined, body, );
    return res;
  }
  syncPriceListCatalogStatus = async (query: ISyncPriceListCatalogStatusRequestQuery) => {
    const res = await Request.call('/api/shopify/sync-price-list-catalog/status', 'GET', undefined, query, undefined, );
    return res;
  }
  syncApprovedBuyingListByLocation = async (body: ISyncApprovedBuyingListByLocationRequestBody) => {
    const res = await Request.call('/api/shopify/sync-approved-buying-list-by-location', 'POST', undefined, undefined, body, );
    return res;
  }
  syncApprovedBuyingListByCompany = async (body: ISyncApprovedBuyingListByCompanyRequestBody) => {
    const res = await Request.call('/api/shopify/sync-approved-buying-list-by-company', 'POST', undefined, undefined, body, );
    return res;
  }
  syncApprovedBuyingListByLocationStatus = async (query: ISyncApprovedBuyingListByLocationStatusRequestQuery) => {
    const res = await Request.call('/api/shopify/sync-approved-buying-list-by-location/status', 'GET', undefined, query, undefined, );
    return res;
  }
  approveDraftOrder = async (body: IApproveDraftOrderRequestBody) => {
    const res = await Request.call('/api/shopify/approve-draft-order', 'POST', undefined, undefined, body, );
    return res;
  }
  getDraftOrder = async (query: IGetDraftOrderRequestQuery) => {
    const res = await Request.call('/api/shopify/get-draft-order', 'GET', undefined, query, undefined, );
    return res;
  }
  saveDraftOrderAmendment = async (body: ISaveDraftOrderAmendmentRequestBody) => {
    const res = await Request.call('/api/shopify/save-draft-order-amendment', 'POST', undefined, undefined, body, );
    return res;
  }
  resetDraftOrderAmendment = async (body: IResetDraftOrderAmendmentRequestBody) => {
    const res = await Request.call('/api/shopify/reset-draft-order-amendment', 'POST', undefined, undefined, body, );
    return res;
  }
  listDraftOrders = async (query: IListDraftOrdersRequestQuery) => {
    const res = await Request.call('/api/shopify/list-draft-orders', 'GET', undefined, query, undefined, );
    return res;
  }
  listLocations = async (query: IListLocationsRequestQuery) => {
    const res = await Request.call('/api/shopify/list-locations', 'GET', undefined, query, undefined, );
    return res;
  }
  cancelDraftOrder = async (body: ICancelDraftOrderRequestBody) => {
    const res = await Request.call('/api/shopify/cancel-draft-order', 'POST', undefined, undefined, body, );
    return res;
  }
  syncCompanyLocationAblFromShopify = async (body: ISyncCompanyLocationAblFromShopifyRequestBody) => {
    const res = await Request.call('/api/shopify/sync-company-location-abl-from-shopify', 'POST', undefined, undefined, body, );
    return res;
  }
  updateDraftOrderPoNumber = async (body: IUpdateDraftOrderPoNumberRequestBody) => {
    const res = await Request.call('/api/shopify/update-draft-order-po-number', 'POST', undefined, undefined, body, );
    return res;
  }
  syncAblMasterFromShopifyByCompany = async (body: ISyncAblMasterFromShopifyByCompanyRequestBody) => {
    const res = await Request.call('/api/shopify/sync-abl-master-from-shopify/by-company', 'POST', undefined, undefined, body, );
    return res;
  }
  syncBCCompanyLocations = async (body: ISyncBCCompanyLocationsRequestBody) => {
    const res = await Request.call('/api/shopify/sync-bc-company-locations', 'POST', undefined, undefined, body, );
    return res;
  }
  syncBCCompanyLocationsStatus = async (query: ISyncBCCompanyLocationsStatusRequestQuery) => {
    const res = await Request.call('/api/shopify/sync-bc-company-locations/status', 'GET', undefined, query, undefined, );
    return res;
  }
}
export default new ShopifyAPI()